import React, { FC } from 'react'
import { Box, Button, Modal, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { isDirtyForm, isNavMenuRoute } from '../../graphql/local'
import { StyledPromtContainer, StyledPromtFooter } from './StyledComponents'

export const CustomPrompt: FC<{
  open: boolean
  onConfirm: () => void
  onCancel: () => void
}> = ({ open, onConfirm, onCancel }) => {
  const { t } = useTranslation()
  const isNavigateAway = isNavMenuRoute()

  function handleConfirm() {
    isDirtyForm(false)
    isNavMenuRoute(false)
    onConfirm()
  }

  const handleCancel = () => {
    isNavMenuRoute(false)
    onCancel()
  }

  const confirmCustomPrompt = (
    <StyledPromtContainer data-test="modalGoBack">
      <Box
        sx={(theme) => ({
          padding: theme.spacing(3, 3, 2),
        })}
      >
        <Typography variant={'h4'}>
          {isNavigateAway
            ? t(
                'areYouSureYouWantToNavigateAwayFromThisPage',
                'Are you sure you want to navigate away from this page',
              )
            : t('areYouSureYouWantToGoBack', 'Are you sure you want to go back')}
          ?
        </Typography>
      </Box>

      <Box sx={(theme) => ({ padding: theme.spacing(0, 3) })}>
        <Typography>
          {t('allUnsubmittedDataWillBeLost', 'All unsubmitted data will be lost')}.
        </Typography>
      </Box>
      <StyledPromtFooter>
        <Button variant="contained" onClick={handleConfirm} data-test="modal-goBack-button">
          {isNavigateAway ? t('navigateAway', 'Navigate away') : t('goBack', 'Go back')}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleCancel}
          data-test="continueEditing"
        >
          {t('continueEditing', 'Continue editing')}
        </Button>
      </StyledPromtFooter>
    </StyledPromtContainer>
  )

  return (
    <Modal
      open={open}
      onClose={onCancel}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      sx={(theme) => ({
        zIndex: theme.zIndex.modal + 10,
      })}
    >
      {confirmCustomPrompt}
    </Modal>
  )
}
